/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import IconUploader from './IconUploader';
import MultiImageUploader from './MultiImageUploader';
import SelectableImageField from './SelectableImageField';
import StaticIconSelector from './StaticIconSelector';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export {
  AvatarDropdown,
  AvatarName,
  Footer,
  Question,
  SelectLang,
  IconUploader,
  MultiImageUploader,
  SelectableImageField,
  StaticIconSelector,
};
